import styled from 'styled-components';
import { minWidth } from 'helpers/buildMediaQueries';
import { gutterVariables } from '@trustedshops/tps-seo-shared-frontend-react-components';

export const NoResultsForKeywordText = styled.span<{
  internationalSearch?: boolean;
}>`
  display: block;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  margin: ${gutterVariables.GUTTER} auto;
  ${(props) =>
    !props.internationalSearch &&
    minWidth('xl', `padding-bottom: ${gutterVariables.GUTTER_DOUBLE};`)}
  ${minWidth('xl', 'max-width: 696px;')}
`;
